import kuPiper from '@/middleware/kuPiper';
import classNames from 'classnames';
import {EDITOR_MODE} from '@/Constant';
import * as store from '@/store';
import {IAiChatPanel} from '@/interface';
import DongTingSDK from '@/components/DongTingSDK';
import HelperCenter from '@/domains/user/HelperCenter';
import {isInKuShare} from '@/utils/urlUtils';
import styles from './index.module.scss';

interface Iprops {
    aiChatPanel?: IAiChatPanel;
    demoMode?: boolean;
    documentMode?: EDITOR_MODE;
}
const RightButtomFixedBtns = (props:Iprops) => {
    const {aiChatPanel, demoMode, documentMode} = props;
    const isTocPage = window.isTocPage;

    // 线上环境 演示模式和历史版本都不显示help，洞听同help显示逻辑， 演示模式和历史版本一键回顶会展示
    // 202508新增：外部知识库不展示洞听和帮助中心
    const showBtn = !demoMode && documentMode !== EDITOR_MODE.history && !isTocPage;

    return (
        <div
            id="doc-rb-fix-btns"
            className={classNames(
                styles.rightButtomFixedBtns,
                aiChatPanel?.isExpanded && styles.fitAiChat,
                aiChatPanel?.isAiAssistant && styles.isAiAssistant,
                demoMode && styles.isDemoMode,
                isInKuShare() && styles.isKuComment,
                documentMode === EDITOR_MODE.history && styles.isHistory
            )}
        >
            <div id="returnTop"></div>
            {showBtn && kuPiper.openNormalReplaceSlot(
                {
                    scope: kuPiper.slotScopeMap.UserHelp,
                    position: kuPiper.slotPositionMap.UserHelp.HelpIcon,
                    DefaultComponent: <HelperCenter />,
                }
            )}
            {showBtn && <DongTingSDK />}
        </div>
    );
};

export default store.connect([
    store.KEYS.AI_CHAT_PANEL,
    store.KEYS.DEMO_MODE,
    store.KEYS.DOCUMENT_MODE,
])(RightButtomFixedBtns);
